import React from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import TaraVenturesWebsite from './components/TaraVenturesWebsite';
import CareersPage from './pages/CareersPage';
import FounderPage from './pages/FounderPage';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<TaraVenturesWebsite />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/founder" element={<FounderPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;